exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".regions-save-changes-button-flex-container {\n  margin-left: 41.6em; }\n\n.regions-settings-page .search-results-table {\n  margin: 0;\n  width: 100%; }\n\n.regions-settings-page .user-profile-card {\n  padding: 1em; }\n", ""]);

